module.exports = __webpack_public_path__ + "img/1f_r_moriyama.a8a5b8d4.png";